const Items = [
    {
        id: 1,
        images: 'images/Breakfast/breakfast1.png',
        name: 'Healthy meal plan',
        category: 'breakfast',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 2,
        images: 'images/Breakfast/breakfast2.png',
        name: 'Fried Chicken Besto',
        category: 'breakfast',
        price: '$2.90',
        description: 'How we dream about our future'
    },
    {
        id: 3,
        images: 'images/Breakfast/breakfast3.png',
        name: 'Healthy meal plan',
        category: 'breakfast',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 4,
        images: 'images/Breakfast/breakfast4.png',
        name: 'Healthy meal plan',
        category: 'breakfast',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 5,
        images: 'images/Breakfast/breakfast5.png',
        name: 'Healthy meal plan',
        category: 'breakfast',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 6,
        images: 'images/Breakfast/breakfast6.png',
        name: 'Healthy meal plan',
        category: 'breakfast',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 7,
        images: 'images/lunch/lunch1.png',
        name: 'Healthy meal plan',
        category: 'lunch',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 8,
        images: 'images/lunch/lunch2.png',
        name: 'Healthy meal plan',
        category: 'lunch',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 9,
        images: 'images/lunch/lunch3.png',
        name: 'Tarragon-Rubbed-Salmon',
        category: 'lunch',
        price: '$9.90',
        description: 'How we dream about our future'
    },
    {
        id: 10,
        images: 'images/lunch/lunch4.png',
        name: 'Fried Chicken Besto',
        category: 'lunch',
        price: '$22.90',
        description: 'How we dream about our future'
    },
    {
        id: 11,
        images: 'images/lunch/lunch5.png',
        name: 'Fried Chicken Besto',
        category: 'lunch',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 12,
        images: 'images/lunch/lunch6.png',
        name: 'Healthy meal plan',
        category: 'lunch',
        price: '$31.90',
        description: 'How we dream about our future'
    },

    {
        id: 13,
        images: 'images/Dinner/dinner1.png',
        name: 'Healthy meal plan',
        category: 'dinner',
        price: '$32.90',
        description: 'How we dream about our future'
    },
    {
        id: 14,
        images: 'images/Dinner/dinner2.png',
        name: 'Healthy meal plan',
        category: 'dinner',
        price: '$9.90',
        description: 'How we dream about our future'
    },
    {
        id: 15,
        images: 'images/Dinner/dinner3.png',
        name: 'Healthy meal plan',
        category: 'dinner',
        price: '$12.90',
        description: 'How we dream about our future'
    },
    {
        id: 16,
        images: 'images/Dinner/dinner4.png',
        name: 'Healthy meal plan',
        category: 'dinner',
        price: '$7.90',
        description: 'How we dream about our future'
    },
    {
        id: 17,
        images: 'images/Dinner/dinner5.png',
        name: 'Healthy meal plan',
        category: 'dinner',
        price: '$5.90',
        description: 'How we dream about our future'
    },
    {
        id: 18,
        images: 'images/Dinner/dinner6.png',
        name: 'Healthy meal plan',
        category: 'dinner',
        price: '$11.90',
        description: 'How we dream about our future'
    },

]

export default Items;